// extracted by mini-css-extract-plugin
export var addButton = "_mw-0";
export var border = "_mw-8";
export var check = "_mw-h";
export var danger = "_mw-6";
export var dropdownContainer = "_mw-1";
export var editModalBody = "_mw-j";
export var footerContainer = "_mw-i";
export var fullWidth = "_mw-a";
export var hide = "_mw-9";
export var icon = "_mw-3";
export var input = "_mw-7";
export var inputFlex = "_mw-b";
export var inputWrapper = "_mw-c";
export var manualFocus = "_mw-5";
export var optionButton = "_mw-4";
export var pillWrapper = "_mw-e";
export var pointer = "_mw-2";
export var showOverflow = "_mw-f";
export var tagsFlex = "_mw-d";
export var xButton = "_mw-g";